/**
 * custom-byob.js
 * Build Your Own Bundle — Shopify Dawn Theme
 */

document.addEventListener('DOMContentLoaded', () => {
 
  // ─────────────────────────────────────────────────────────────────────────
  // 1. DOM REFERENCES
  // ─────────────────────────────────────────────────────────────────────────
  const mainATCButton     = document.querySelector('.byob-atc-btn');
  const progressFill      = document.querySelector('.progress-fill');
  const progressBar       = document.querySelector('.progress-bar');
  const headerCount       = document.querySelector('.byob-header-title-count');
  const headerCountMbl    = document.querySelector('.byob-header-title-count-mobile')
  const previewBtn        = document.querySelector('.byob-tier-preview-indicator button');
  const placeholders      = document.querySelectorAll('.byob-item-holder');
  const byobBoxDrawer     = document.querySelector('.byob-custom-build-container');
  const byobDrawerTrigger = document.querySelector('.byob-drawer-opener');
  const byobRemainingToAddItems = document.querySelector('.remaining-items-to-add');
  const amountToBeSaved = document.querySelector('.amount-to-be-saved');
  const byobSavingsMbl  = document.querySelector('.byob-savings-offer');
  const freeShippingOfferText    = document.querySelector('.save-step-free-shipping');
  const isMobile = window.innerWidth < 990;
  const bundleType = document.querySelector('.byob-button-active').dataset.bundleType;

  const level0El = document.querySelector('.progress-level-0');
  const level1El = document.querySelector('.progress-level-1');
  const level2El = document.querySelector('.progress-level-2');
  const level3El = document.querySelector('.progress-level-3');

  // ─────────────────────────────────────────────────────────────────────────
  // 2. TIER CONSTANTS
  // ─────────────────────────────────────────────────────────────────────────
  const LEVEL1 = parseInt(level1El?.dataset.items || 12);
  const LEVEL2 = parseInt(level2El?.dataset.items || 18);
  const LEVEL3 = parseInt(level3El?.dataset.items || 24);

  function parseSaving(el) {
    const txt = el?.querySelector('.save-circle')?.textContent || '';
    const m   = txt.match(/\$(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : 0;
  }
  const SAVE1 = parseSaving(level1El);
  const SAVE2 = parseSaving(level2El);
  const SAVE3 = parseSaving(level3El);

  // ─────────────────────────────────────────────────────────────────────────
  // 3. BUNDLE STATE
  // ─────────────────────────────────────────────────────────────────────────

  let bundleCounter = 0;

  function generateBundleId() {
    bundleCounter++;
    // return `bundle_${Date.now()}_${bundleCounter}_${Math.random().toString(36).slice(2, 6)}`;
    return Date.now();
  }

  let bundle = {
    items:    {},
    // bundleId: 'bundle_' + Date.now()
    bundleId: generateBundleId()
  };

  // ─────────────────────────────────────────────────────────────────────────
  // 4. ONE-TIME SETUP
  // ─────────────────────────────────────────────────────────────────────────
  if (progressBar) progressBar.style.overflow = 'visible';

  if (previewBtn) {
    previewBtn.closest('.byob-tier-preview-indicator').style.display = 'none';
  }

  const tierIndicator = document.querySelector('.byob-tier-preview-indicator');
  if (tierIndicator && !document.querySelector('.byob-total-savings')) {
    const s = document.createElement('p');
    s.className = 'byob-total-savings';
    s.style.cssText = 'display:none;font-weight:700;color:#8b3a50;margin:0 0 .5rem;'
                    + 'font-size:1.4rem;text-align:center;letter-spacing:.05em;';
    tierIndicator.parentNode.insertBefore(s, tierIndicator);
  }
  const savingsEl = document.querySelector('.byob-total-savings');

  // Purchase option rows — now in HTML, just wire them up
  const otpRow = document.getElementById('byob-otp-row');
  const subRow = document.getElementById('byob-sub-row');
  let   isSubscribe = false;

  function setSubRowDisabled(disabled) {
    if (!subRow) return;
    if (disabled) {
      subRow.classList.add('disabled-row');
      if (isSubscribe) selectOTP();
    } else {
      subRow.classList.remove('disabled-row');
    }
  }
  setSubRowDisabled(true); // disabled by default until product added

  function selectOTP() {
    isSubscribe = false;
    otpRow?.classList.add('selected');
    subRow?.classList.remove('selected');
  }

  function selectSub() {
    isSubscribe = true;
    subRow?.classList.add('selected');
    otpRow?.classList.remove('selected');
  }

  otpRow?.addEventListener('click', selectOTP);
  subRow?.addEventListener('click', () => {
    if (!subRow.classList.contains('disabled-row')) selectSub();
  });

  // ─────────────────────────────────────────────────────────────────────────
  // 5. PURE HELPER FUNCTIONS
  // ─────────────────────────────────────────────────────────────────────────
  function totalCount() {
    return Object.values(bundle.items).reduce((s, it) => s + it.qty, 0);
  }
  function totalRawPrice() {
    return Object.values(bundle.items).reduce((s, it) => s + it.price * it.qty, 0);
  }
  function currentSaving(count) {
    if (count >= LEVEL3) return SAVE3;
    if (count >= LEVEL2) return SAVE2;
    if (count >= LEVEL1) return SAVE1;
    return 0;
  }
  function nextMilestone(count) {
    if (count < LEVEL1) return LEVEL1;
    if (count < LEVEL2) return LEVEL2;
    return LEVEL3;
  }

  function getMatchedSellingPlan(variantId) {
    const freqSelect = document.querySelector('.byob-freq-select');
    if (!freqSelect) return null;

    const selectedFreqHandle = freqSelect.value;
    const productEl = document.querySelector(`.byob-bundle-item[data-variant-id="${variantId}"]`);
    if (!productEl) return null;
    const subSelect = productEl.querySelector('.subscription-frequency');
    if (!subSelect) return null;

    const options = subSelect.querySelectorAll('option');

    for (let opt of options) {
      const planHandle = opt.dataset.planName;
      if (planHandle === selectedFreqHandle) {
        return {
          planId: opt.value,
          frequency: opt.textContent.trim()
        };
      }
    }

    return null;
  }

  async function applyBundleDiscount(count) {
    let discountCode = '';

    if (count >= LEVEL3) {
      discountCode = `bundle${LEVEL3}qty`;
    } else if (count >= LEVEL2) {
      discountCode = `bundle${LEVEL2}qty`;
    } else if (count >= LEVEL1) {
      discountCode = `bundle${LEVEL1}qty`;
    }

    if (!discountCode) return;

    try {
      
      await fetch('/discount/clear', {
        method: 'GET',
        credentials: 'same-origin'
      });

      if(!isSubscribe){
        await fetch(`/discount/${discountCode}`, {
          method: 'GET',
          credentials: 'same-origin'
        });
      }
      

      // console.log('Discount applied:', discountCode);

    } catch (err) {
      console.error('Discount error:', err);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // 6. UI UPDATE FUNCTIONS
  // ─────────────────────────────────────────────────────────────────────────
  // function updateProgress(count) {
  //   if (!progressFill) return;
  //   progressFill.style.width   = Math.min((count / LEVEL3) * 100, 100) + '%';
  //   progressFill.style.display = 'block';
  // }

  function updateProgress(count) {
    if (!progressFill) return;
    let progress = 0;

    // Save $0 tick is at left: 25px. On ~343px inner bar width, that's ~7.3%
    // So we map: 0 items = 7.3% (sits under Save $0 tick), 18 items = 50%, 24 items = 100%
    // 4.4% for 15px left value
    const BASE = 4.4; // percentage that aligns with the Save $0 tick at left:25px
    

    // if (isMobile) {
    //   if (count === 0) {
    //     progress = BASE;
    //   } else if (count <= LEVEL2) {
    //     // Grow from BASE% up to 50% as items go from 0 → LEVEL2
    //     progress = BASE + ((count / LEVEL2) * (50 - BASE));
    //   } else {
    //     // Grow from 50% to 100% as items go from LEVEL2 → LEVEL3
    //     progress = 50 + ((count - LEVEL2) / (LEVEL3 - LEVEL2)) * 50;
    //   }
    // } else {
    //   progress = (count / LEVEL3) * 100;
    // }

    if (count === 0) {
      progress = BASE;
      progressFill.style.width = Math.min(progress, 100) + '%';
    }else{
      progressFill.style.width   = Math.min((count / LEVEL3) * 100, 100) + '%';
    }

    // progressFill.style.width = Math.min(progress, 100) + '%';
    progressFill.style.display = 'block';
  }

  function updateHeader(count) {
    if (!headerCount) return;
    headerCount.innerHTML = `${count} / <strong>${nextMilestone(count)}</strong>`;
    headerCountMbl.innerHTML = `${count} Packs`;
    // byobRemainingToAddItems.innerHTML = Math.max(nextMilestone(count) - count, 0);
    let targetLevel;
    let save;

    if (count < LEVEL2) {
      targetLevel = LEVEL2;
      save = SAVE2;
    } else {
      targetLevel = LEVEL3;
      save = SAVE3;
    }

    byobRemainingToAddItems.innerHTML = Math.max(targetLevel - count, 0);

    if (amountToBeSaved) {
      amountToBeSaved.innerHTML = `$${save}`;
    }

    if(isMobile){ 
      if(count == LEVEL2){
        byobBoxDrawer.classList.add('partial-expanded');
      }else if (count < LEVEL2) {
        byobBoxDrawer.classList.remove('partial-expanded');
      }
    }

    if (count >= LEVEL3) {
      document.querySelector('.byob-progress-success-text').classList.remove('hidden');
      document.querySelector('.byob-progress-text').classList.add('hidden');
      if(isMobile){
        updateBundleDrawerClass()
      }
      
    } else {  
      document.querySelector('.byob-progress-success-text').classList.add('hidden');
      document.querySelector('.byob-progress-text').classList.remove('hidden');
    }

  }

  function updateATC(count) {
    if (!mainATCButton) return;
    // count < LEVEL1 ? mainATCButton.setAttribute('disabled', true) : mainATCButton.removeAttribute('disabled');
    if (count < LEVEL1 || (count !== LEVEL1 && count !== LEVEL2 && count !== LEVEL3)) {
      mainATCButton.setAttribute('disabled', true);
    } else {
      mainATCButton.removeAttribute('disabled');
    }
  }

  function updateBundleDrawerClass() {
    const hasExpanded = byobBoxDrawer.classList.contains('expanded');
    const hasPartial = byobBoxDrawer.classList.contains('partial-expanded');

    if (hasExpanded && hasPartial) {
      byobBoxDrawer.classList.remove('expanded', 'partial-expanded');
    } else if (hasExpanded) {
      byobBoxDrawer.classList.remove('expanded');
    } else {
      byobBoxDrawer.classList.add('expanded');
      byobBoxDrawer.classList.remove('partial-expanded');
    }
  }

  // function updateSavings(count) {
  //   if (!savingsEl) return;
  //   const save = currentSaving(count);
  //   if (save > 0) {
  //     savingsEl.style.display = 'block';
  //     savingsEl.innerHTML = `TOTAL SAVINGS: <span style="color:#8b3a50;">$${save.toFixed(2)}</span>`;
  //   } else {
  //     savingsEl.style.display = 'none';
  //   }
  // }

  function updateSavings(count) {
    if (!savingsEl) return;

    const save = currentSaving(count);

    if (save > 0) {
      savingsEl.style.display = 'block';

      // Check if LEVEL3 reached
      let isFreeShipping;
      if ( bundleType == '4-25oz' ){
        isFreeShipping = count >= LEVEL3;
      }else{
        isFreeShipping = count >= LEVEL2;
      }

      if (isFreeShipping) {
        savingsEl.innerHTML = `TOTAL SAVINGS: <span style="color:#8b3a50;">$${save.toFixed(2)}</span> + FREE SHIPPING`;
      } else {
        savingsEl.innerHTML = `TOTAL SAVINGS: <span style="color:#8b3a50;">$${save.toFixed(2)}</span>`;
      }

    } else {
      savingsEl.style.display = 'none';
    }
  }

  function updatePriceSection(count) {
    const raw   = totalRawPrice();
    const save  = currentSaving(count);
    const final = raw - save;
    const finalSub = raw * 0.8;
    const sub   = final * 0.8;

    const otpDisplay = document.getElementById('byob-otp-price-display');
    const subDisplay = document.getElementById('byob-sub-price-display');

    if (otpDisplay) {
      if (count === 0) {
        otpDisplay.innerHTML = '';
      } else if (save > 0) {
        otpDisplay.innerHTML =
          `<strong>$${final.toFixed(2)}</strong>`
          + `<span class="byob-price-strike">$${raw.toFixed(2)}</span>`;
      } else {
        otpDisplay.innerHTML = `<strong>$${raw.toFixed(2)}</strong>`;
      }
    }

    if (subDisplay) {
      subDisplay.innerHTML = count === 0 ? ''
        : `<strong>$${finalSub.toFixed(2)}</strong>`
          + `<span class="byob-price-strike">$${raw.toFixed(2)}</span>`;
    }
  }

  // function updateTierHighlight(count) {
  //   const tiers = [
  //     { el: level1El, threshold: LEVEL1 },
  //     { el: level2El, threshold: LEVEL2 },
  //     { el: level3El, threshold: LEVEL3 },
  //   ];
  //   tiers.forEach(({ el, threshold }, index) => {
  //     if (!el) return;
  //     const circle = el.querySelector('.save-circle');
  //     const label  = el.querySelector('span.level-item-number');
  //     if (!circle) return;
  //     if (count >= threshold) {
  //       circle.classList.add('reached');
  //       reachedIndex = index;
  //       if (label) label.style.fontWeight = '800';
  //     } else {
  //       circle.classList.remove('reached');
  //       if (label) label.style.fontWeight = '600';
  //     }

  //   });
  // }

  // free shipping modification
// function updateTierHighlight(count) {
//   const tiers = [
//     { el: level0El, type: 'zero' },
//     { el: level1El, type: 'level1', threshold: LEVEL1 },
//     { el: level2El, type: 'level2', threshold: LEVEL2 },
//     { el: level3El, type: 'level3', threshold: LEVEL3 }
//   ];

//   tiers.forEach(({ el }) => {
//     if (!el) return;

//     const circle = el.querySelector('.save-circle');
//     const label = el.querySelector('.level-item-number') || el.querySelector('.pack-number-level');
//     const freeShipping = el.querySelector('.save-step-free-shipping');

//     el.classList.remove('reached');
//     if (circle) circle.classList.remove('reached');
//     if (label) label.style.fontWeight = '600';
//     if (freeShipping) freeShipping.style.display = 'none';
//   });

//   let activeTier = null;

//   if (count === 0) {
//     activeTier = level0El;
//   } else if (count >= LEVEL3) {
//     activeTier = level3El;
//   } else if (count >= LEVEL2) {
//     activeTier = level2El;
//   } else if (count >= LEVEL1) {
//     activeTier = level1El;
//   }

//   if (activeTier) {
//     const circle = activeTier.querySelector('.save-circle');
//     const label =
//       activeTier.querySelector('.level-item-number') ||
//       activeTier.querySelector('.pack-number-level');

//     activeTier.classList.add('reached');
//     if (circle) circle.classList.add('reached');
//     if (label) label.style.fontWeight = '800';
//   }

//   let upcomingTier = null;

//   if (count < LEVEL2) {
//     upcomingTier = level2El;
//   } else if (count < LEVEL3) {
//     upcomingTier = level3El;
//   }

//   if (upcomingTier) {
//     const freeShipping = upcomingTier.querySelector('.save-step-free-shipping');
//     if (freeShipping) freeShipping.style.display = 'inline';
//   }
// }

  function updateTierHighlight(count) {
    const tiers = [
      { el: level0El, type: 'zero' },
      { el: level1El, type: 'level1', threshold: LEVEL1 },
      { el: level2El, type: 'level2', threshold: LEVEL2 },
      { el: level3El, type: 'level3', threshold: LEVEL3 }
    ];

    tiers.forEach(({ el, type }) => {
      if (!el) return;

      const circle = el.querySelector('.save-circle');
      const label =
        el.querySelector('.level-item-number') ||
        el.querySelector('.pack-number-level');
      const freeShipping = el.querySelector('.save-step-free-shipping');

      el.classList.remove('reached');
      if (circle) circle.classList.remove('reached');
      if (label) label.style.fontWeight = '600';

      if (freeShipping) freeShipping.style.display = 'none';

      if (type === 'level3' && count === LEVEL3 && freeShipping) {
        // freeShipping.style.display = 'inline';
      }
    });

    let activeTier = null;

    if (count === 0) {
      activeTier = level0El;
    } else if (count >= LEVEL3) {
      activeTier = level3El;
    } else if (count >= LEVEL2) {
      activeTier = level2El;
    } else if (count >= LEVEL1) {
      activeTier = level1El;
    }

    if (activeTier) {
      const circle = activeTier.querySelector('.save-circle');
      const label =
        activeTier.querySelector('.level-item-number') ||
        activeTier.querySelector('.pack-number-level');

      activeTier.classList.add('reached');
      if (circle) circle.classList.add('reached');
      if (label) label.style.fontWeight = '800';
    }
  }

  function updateSubscribeAvailability(count) {
    setSubRowDisabled(count === 0);
    if (count === 0 && isSubscribe) selectOTP();
  }

  function updateAddBtns(count) {
    document.querySelectorAll('.byob-bundle-item').forEach(product => {
      const addBtn     = product.querySelector('.bundle-product-atc');
      const qtyWrapper = product.querySelector('quantity-input');
      if (!addBtn || qtyWrapper?.style.display === 'flex') return;
      const isFull = count >= LEVEL3;
      addBtn.disabled            = isFull;
      addBtn.style.opacity       = isFull ? '0.4' : '';
      addBtn.style.cursor        = isFull ? 'not-allowed' : '';
      addBtn.style.pointerEvents = isFull ? 'none' : '';
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // 7. PREVIEW GRID REBUILD
  // ─────────────────────────────────────────────────────────────────────────
  function updatePreview() {
    const allItems = [];
    Object.values(bundle.items).forEach(item => {
      for (let i = 0; i < item.qty; i++) allItems.push(item);
    });
    const count = allItems.length;

    placeholders.forEach((holder, i) => {
      const preview     = holder.querySelector('.byob-added-item-preview');
      const emptyHolder = holder.querySelector('.byob-item-placeholder');
      holder.querySelector('.byob-remove-item')?.remove();

      if (allItems[i]) {
        const item = allItems[i];
        if (preview) {
          preview.innerHTML = `<img src="${item.image}" alt="" style="width:100%;height:100%;object-fit:contain;display:block;">`;
          preview.style.display = 'block';
        }
        if (emptyHolder) emptyHolder.style.display = 'none';
        holder.style.position = 'relative';

        const xBtn = document.createElement('button');
        xBtn.className = 'byob-remove-item';
        xBtn.innerHTML = '<i aria-hidden="true" class="fal fa-times"></i>';
        xBtn.setAttribute('aria-label', 'Remove item');
        xBtn.addEventListener('click', e => {
          e.preventDefault(); e.stopPropagation();
          removeOneFromBundle(item.variantId);
        });
        holder.appendChild(xBtn);
      } else {
        if (preview)     { preview.innerHTML = ''; preview.style.display = 'none'; }
        if (emptyHolder) emptyHolder.style.display = '';
        holder.style.position = '';
      }
    });

    updateProgress(count);
    updateHeader(count);
    updateATC(count);
    updateSavings(count);
    updatePriceSection(count);
    updateTierHighlight(count);
    updateSubscribeAvailability(count);
    updateAddBtns(count);
  }

  // ─────────────────────────────────────────────────────────────────────────
  // 8. BUNDLE MUTATION HELPERS
  // ─────────────────────────────────────────────────────────────────────────
  function removeOneFromBundle(variantId) {
    if (!bundle.items[variantId]) return;
    bundle.items[variantId].qty -= 1;
    if (bundle.items[variantId].qty <= 0) delete bundle.items[variantId];

    const productEl = document.querySelector(`.byob-bundle-item[data-variant-id="${variantId}"]`);
    if (productEl) {
      const qtyInput   = productEl.querySelector('input[type="number"]');
      const qtyWrapper = productEl.querySelector('quantity-input');
      const addBtn     = productEl.querySelector('.bundle-product-atc');
      const newQty     = bundle.items[variantId]?.qty || 0;
      if (qtyInput) qtyInput.value = newQty;
      if (newQty === 0) {
        if (qtyWrapper) qtyWrapper.style.display = 'none';
        if (addBtn) { addBtn.style.display = 'block'; addBtn.disabled = false; addBtn.style.opacity = ''; }
      }
    }
    updatePreview();
  }

  function updateBundle(productEl, qty) {
    const variantId = productEl.dataset.variantId;
    const image     = productEl.dataset.image;
    const price     = parseFloat(productEl.dataset.price) || 0;
    if (qty === 0) { delete bundle.items[variantId]; }
    else { bundle.items[variantId] = { variantId, image, qty, price }; }
    updatePreview();
  }

  // ─────────────────────────────────────────────────────────────────────────
  // 9. PRODUCT CARD WIRING
  // ─────────────────────────────────────────────────────────────────────────
  document.querySelectorAll('.byob-bundle-item').forEach(product => {
    const addBtn     = product.querySelector('.bundle-product-atc');
    const qtyInput   = product.querySelector('input[type="number"]');
    const qtyWrapper = product.querySelector('quantity-input');
    if (!addBtn || !qtyInput || !qtyWrapper) return;

    addBtn.addEventListener('click', () => {
      if (totalCount() >= LEVEL3) return;
      addBtn.style.display     = 'none';
      qtyWrapper.style.display = 'flex';
      qtyInput.value           = 1;
      updateBundle(product, 1);
    });

    function handleQtyChange() {
      let qty = parseInt(qtyInput.value) || 0;
      if (qty < 0) qty = 0;
      const existing = bundle.items[product.dataset.variantId]?.qty || 0;
      const headroom = LEVEL3 - (totalCount() - existing);
      if (qty > headroom) { qty = Math.max(0, headroom); qtyInput.value = qty; }
      if (qty <= 0) {
        qtyInput.value = 0; qtyWrapper.style.display = 'none';
        addBtn.style.display = 'block'; updateBundle(product, 0);
      } else { updateBundle(product, qty); }
    }

    qtyInput.addEventListener('change', handleQtyChange);
    qtyInput.addEventListener('input', () => {
      clearTimeout(qtyInput._byobTimer);
      qtyInput._byobTimer = setTimeout(handleQtyChange, 80);
    });
  });

  // ─────────────────────────────────────────────────────────────────────────
  // 10. TIER CIRCLE INTERACTIONS
  // ─────────────────────────────────────────────────────────────────────────
  const tooltip = document.createElement('div');
  tooltip.textContent = 'Click to select';
  tooltip.style.cssText =
    'position:fixed;background:#9b3462f2;color:#fff;font-size:11px;font-weight:600;'
    + 'white-space:nowrap;padding:4px 10px;border-radius:4px;pointer-events:none;'
    + 'z-index:9999;opacity:0;transition:opacity .15s;';
  tooltip.innerHTML += '<span style="position:absolute;top:100%;left:50%;transform:translateX(-50%);'
    + 'border:5px solid transparent;border-top-color:#333;display:none;"></span>';
  document.body.appendChild(tooltip);

  [level1El, level2El, level3El].forEach(stepEl => {
    if (!stepEl) return;
    const circle = stepEl.querySelector('.save-circle');
    if (!circle) return;

    circle.addEventListener('mouseenter', () => {
      const rect = circle.getBoundingClientRect();
      tooltip.style.top       = (rect.top - tooltip.offsetHeight - -14) + 'px';
      tooltip.style.left      = (rect.left + rect.width / 2) + 'px';
      tooltip.style.transform = 'translateX(-50%)';
      tooltip.style.opacity   = '1';
    });
    circle.addEventListener('mouseleave', () => { tooltip.style.opacity = '0'; });

    circle.addEventListener('click', () => {
      tooltip.style.opacity = '0';
      const tierItems = parseInt(stepEl.dataset.items);
      const save      = parseSaving(stepEl);
      if (tierIndicator) tierIndicator.style.display = 'block';
      if (previewBtn) {
        let html = `Preview: <strong>${tierItems}</strong> items bundle`;
        if (save > 0) html += ` (Save $${save})`;
        previewBtn.innerHTML = html;
      }
      if (headerCount) {
        headerCount.innerHTML = `${totalCount()} / <strong>${tierItems}</strong>`;
        headerCount.innerHTML = `${totalCount()} Packs`;
      }
    });
  });


// ─────────────────────────────────────────────────────────────────────────
// 11. ADD BUNDLE TO CART
// ─────────────────────────────────────────────────────────────────────────
// mainATCButton?.addEventListener('click', async () => {
//   if (!Object.keys(bundle.items).length) return;

//   bundle.bundleId = generateBundleId();

//   const subscriptionId = isSubscribe ? 'sub_' + Date.now() : null;
//   const freqSelect     = document.querySelector('.byob-freq-select');

//   const items = Object.values(bundle.items).map(item => {
//     const properties = {
//       _bundle_group_id: bundle.bundleId,
//       _unique: generateBundleId(),
//       _bundle_type: bundleType || ''
//     };

//     // if (isSubscribe) {
//     //   properties.subscription_id   = subscriptionId;
//     //   properties.frequency         = freqSelect?.value || 'every-1-month';
//     //   properties._is_subscription  = 'true';
//     //   properties._discount_applied = '20%';
//     // }

//     if (isSubscribe) {
//       const matchedPlan = getMatchedSellingPlan(item.variantId);

//       if (matchedPlan) {
//         properties._subscription_id   = matchedPlan.planId;
//         properties._frequency         = matchedPlan.frequency;
//       } else {
//         // fallback (safe)
//         properties._subscription_id   = '';
//         // properties.frequency         = freqSelect?.value || '';
//         properties._frequency         = '';
//       }

//       properties._is_subscription  = 'true';
//       properties._discount_applied = '20%';
//     }

//     const lineItem = {
//       id:       parseInt(item.variantId),
//       quantity: item.qty,
//       properties
//     };

//     if (isSubscribe) {
//       const matchedPlan = getMatchedSellingPlan(item.variantId);
//       if (matchedPlan && matchedPlan.planId) {
//         lineItem.selling_plan = parseInt(matchedPlan.planId);
//       }
//     }

//     return lineItem;
//   });

//   mainATCButton.setAttribute('disabled', true);
//   mainATCButton.classList.add('loading');
//   const spinner = mainATCButton.querySelector('.loading__spinner');
//   if (spinner) spinner.classList.remove('hidden');

//   try {
//     const addRes = await fetch('/cart/add.js', {
//       method:  'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body:    JSON.stringify({ items })
//     });
//     if (!addRes.ok) throw new Error('Cart add failed: ' + addRes.status);

//     await new Promise(r => setTimeout(r, 500));
//     if (!isSubscribe) {
//       await applyBundleDiscount(totalCount());
//     }
//     const sectionsData = await fetchCartSections();
//     patchTrapFocus();

//     if (sectionsData) {
//       injectCartDrawerHTML(sectionsData['cart-drawer']);
//       injectCartIconHTML(sectionsData['cart-icon-bubble']);
//     }

//     await new Promise(r => setTimeout(r, 50));
    
    
//     updateBundleDrawerClass();
//     openDawnCartDrawer();

//   } catch (err) {
//     console.error('[BYOB] Cart error:', err);
//     // window.location.href = '/cart';
//   } finally {
//     mainATCButton.classList.remove('loading');
//     if (spinner) spinner.classList.add('hidden');
//     updateATC(totalCount());
//   }
// });

// optimized experiment of add bundle to cart - bckp above
  let atcAbortController = null;

  mainATCButton?.addEventListener('click', async () => {
    if (!Object.keys(bundle.items).length) return;

    // Cancel any in-flight request from a previous click
    if (atcAbortController) atcAbortController.abort();
    atcAbortController = new AbortController();
    const { signal } = atcAbortController;

    bundle.bundleId = generateBundleId();

    // Build items — call getMatchedSellingPlan ONCE per item, not twice
    const items = Object.values(bundle.items).map(item => {
      const matchedPlan = isSubscribe ? getMatchedSellingPlan(item.variantId) : null;

      const properties = {
        _bundle_group_id: bundle.bundleId,
        _unique:          generateBundleId(),
        _bundle_type:     bundleType || '',
      };

      if (isSubscribe) {
        properties._subscription_id  = matchedPlan?.planId  || '';
        properties._frequency        = matchedPlan?.frequency || '';
        properties._is_subscription  = 'true';
        properties._discount_applied = '20%';
      }

      const lineItem = {
        id:         parseInt(item.variantId),
        quantity:   item.qty,
        properties,
      };

      if (isSubscribe && matchedPlan?.planId) {
        lineItem.selling_plan = parseInt(matchedPlan.planId);
      }

      return lineItem;
    });

    // Disable button + show spinner
    mainATCButton.setAttribute('disabled', true);
    mainATCButton.classList.add('loading');
    const spinner = mainATCButton.querySelector('.loading__spinner');
    spinner?.classList.remove('hidden');

    try {
      const addRes = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
        signal,
      });

      if (!addRes.ok) throw new Error('Cart add failed: ' + addRes.status);

      // Run discount + section fetch in PARALLEL — no artificial delays
      const [sectionsData] = await Promise.all([
        fetchCartSections(),
        !isSubscribe ? applyBundleDiscount(totalCount()) : Promise.resolve(),
      ]);

      patchTrapFocus();
      if (sectionsData) {
        injectCartDrawerHTML(sectionsData['cart-drawer']);
        injectCartIconHTML(sectionsData['cart-icon-bubble']);
      }

    //   updateBundleDrawerClass();

      if(byobBoxDrawer.classList.contains('expanded')){
        byobBoxDrawer.classList.remove('expanded')
      }
      if(byobBoxDrawer.classList.contains('partial-expanded')){
        byobBoxDrawer.classList.remove('partial-expanded')
      }

      openDawnCartDrawer();

    } catch (err) {
      if (err.name === 'AbortError') return; // Stale click — silently ignore
      console.error('[BYOB] Cart error:', err);
    } finally {
      mainATCButton.classList.remove('loading');
      spinner?.classList.add('hidden');
      updateATC(totalCount());
    }
  });

  // ─────────────────────────────────────────────────────────────────────────
  // 12. CART HELPER FUNCTIONS
  // ─────────────────────────────────────────────────────────────────────────
  function patchTrapFocus() {
    if (window.__byobTrapFocusPatched) return;
    window.__byobTrapFocusPatched = true;
    if (typeof window.trapFocus !== 'function') return;
    const orig = window.trapFocus;
    window.trapFocus = function(container, elementToFocus) {
      if (!container) return;
      try {
        const f = container.querySelectorAll(
          'summary,a[href],button:enabled,[tabindex]:not([tabindex^="-"]),' +
          'input:not([type=hidden]):enabled,select:enabled,textarea:enabled,object,iframe'
        );
        if (!f || f.length === 0) return;
      } catch(e) { return; }
      orig.call(this, container, elementToFocus);
    };
  }

  async function fetchCartSections() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      if (!res.ok) { console.warn('[BYOB] sections fetch:', res.status); return null; }
      const text = await res.text();
      if (!text.trimStart().startsWith('{')) { console.warn('[BYOB] not JSON'); return null; }
      return JSON.parse(text);
    } catch(e) { console.warn('[BYOB] fetchCartSections:', e); return null; }
  }

  function injectCartDrawerHTML(html) {
    if (!html) return;
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const freshDrawer = tmp.querySelector('cart-drawer');
    if (!freshDrawer) return;
    const targetInner = cartDrawerEl.querySelector('.drawer__inner');
    const freshInner  = freshDrawer.querySelector('.drawer__inner');
    if (targetInner && freshInner) {
      targetInner.innerHTML = freshInner.innerHTML;
    } else {
      cartDrawerEl.innerHTML = freshDrawer.innerHTML;
    }
    cartDrawerEl.classList.remove('is-empty');
    cartDrawerEl.querySelectorAll('.is-empty').forEach(el => el.classList.remove('is-empty'));
    const emptyBlock  = cartDrawerEl.querySelector('.drawer__inner-empty');
    if (emptyBlock) emptyBlock.style.display = 'none';
    const checkoutBtn = cartDrawerEl.querySelector('#CartDrawer-Checkout');
    if (checkoutBtn) checkoutBtn.removeAttribute('disabled');
  }

  function injectCartIconHTML(html) {
    if (!html) return;
    const iconEl = document.getElementById('cart-icon-bubble');
    if (!iconEl) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const fresh = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild;
    if (fresh) iconEl.innerHTML = fresh.innerHTML;
  }

  function openDawnCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) { window.location.href = '/cart'; return; }
    if (typeof cartDrawer.open === 'function') { cartDrawer.open(); return; }
    cartDrawer.classList.add('animate', 'active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay, .cart-drawer__overlay');
    if (overlay) { overlay.style.display = 'block'; overlay.removeAttribute('aria-hidden'); }
    const closeBtn = cartDrawer.querySelector('.drawer__close, [id*="CartDrawer-Close"]');
    if (closeBtn) setTimeout(() => closeBtn.focus(), 100);
  }

  // ─────────────────────────────────────────────────────────────────────────
  // 13. TOP BUTTON
  // ─────────────────────────────────────────────────────────────────────────
  function wireTopButton() {
    const topSelectors = [
      'a[href="#top"]', 'a[href="#MainContent"]', '.back-to-top',
      '[data-scroll-top]', '[aria-label="Back to top"]', '[aria-label*="top" i]',
    ];
    document.querySelectorAll(topSelectors.join(',')).forEach(btn => {
      if (btn._byobTopWired) return;
      btn._byobTopWired = true;
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.scrollBy({ top: +100, behavior: 'smooth' });
      });
    });
  }
  wireTopButton();
  setTimeout(wireTopButton, 300);
  setTimeout(wireTopButton, 1000);

  // ─────────────────────────────────────────────────────────────────────────
  // 14. INITIAL RENDER
  // ─────────────────────────────────────────────────────────────────────────
  updatePreview();
  updateTierHighlight(totalCount());

  // ----------------------------------------------------------------------------
  // 15. MOBILE DRAWER OPENING
  // ----------------------------------------------------------------------------
  byobDrawerTrigger?.addEventListener('click', () => {
    if(!byobBoxDrawer) return;
    updateBundleDrawerClass()
  })

});